import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IAllowedTradesSearchParam,
  IAllowedTradesTableReport,
} from "../../../Interfaces/deltaHedgeExe";
import { CommonTableUI } from "../../TableTemplate/common";
import { getDeltaHedgeExeAllowedTradesTable } from "../../../Requests/deltaHedgeExe";
import { Additional } from "./Additional";

interface IProps {
  searchParams: IAllowedTradesSearchParam;
}

const AllowedTradesTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IAllowedTradesSearchParam, IAllowedTradesTableReport>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
        />
      )}
      getDataTable={getDeltaHedgeExeAllowedTradesTable}
      searchParameters={searchParams}
    />
  );
};

export default AllowedTradesTable;
